import styles from './provider-list-card.module.css';
import clsx from 'clsx';
import { ProviderImageSvg } from '@/components/svgs/provider-image';
import { useTranslation } from '@/contexts/i18n-context';

const translationBase = 'visit.providerSelection.selectedProvider.nextAvailableProviderCard';

export function NextAvailableProviderListCard() {
  const { t } = useTranslation();

  return (
    <div className={styles.detailsContainer}>
      <ProviderImageSvg className={styles.providerImg} />

      <div className={styles.providerDetails}>
        <h1 className={clsx('body-1', 'bold')}>{t(`${translationBase}.title`)}</h1>
        <span className="body-3">{t(`${translationBase}.subTitle`)}</span>
      </div>
    </div>
  );
}
